import styled from 'styled-components';
import { container, flexPosition, fontStyle } from '../../styles/mixins';
import {
  FONT_SIZE_1,
  FONT_WEIGHT_BOLD,
  GRAY_DARKER,
  GRAY_LIGHTER_2,
  WHITE,
} from '../../styles/variables';
import { ZINDEX } from '../../helpers/constants';

export const NavbarOuter = styled.div`
  ${props => props.changeHeight && `height: 200px`}
`;

export const NavbarContainer = styled.div`
  width: 100%;
  background-color: ${WHITE};
  z-index: ${ZINDEX.TOP};
  top: 60px;
  margin-top: ${({ hideHeaderTitle }) => (hideHeaderTitle ? '0px' : '5px')};
  ${({ noMargin }) => noMargin && `margin-top: 0px;`}
  ${props => `position: ${props.hideHeaderTitle ? 'fixed' : 'inherit'}`}
  box-shadow: ${({ boxShadow }) => (boxShadow ? '0px 0px 8px -1px rgba(0, 0, 0, 0.1)' : 'unset')};
`;

export const Content = styled.div`
  ${container()}
  ${flexPosition({ align: 'center', justify: 'space-between' })}
  background-color: ${WHITE};
`;

export const HeaderTitle = styled.div`
  padding: 35px 0px;
  border-bottom: 1px solid ${GRAY_LIGHTER_2};
  ${props => `display: ${props.hideHeaderTitle ? 'none' : 'inherit'}`}
`;

export const Title = styled.h1`
  ${fontStyle(GRAY_DARKER, FONT_SIZE_1, FONT_WEIGHT_BOLD)}
`;



// WEBPACK FOOTER //
// ./src/components/Navbar/style.js